var ContactSalesStrings = {
    pageTitle: function () { return 'Contact Sales'; },
    pageSubtitle: function () {
        return "Get in touch if you're interested in learning more about DoorDash for Work.";
    },
    leadForm: {
        firstName: {
            label: function () { return 'First Name'; },
        },
        lastName: {
            label: function () { return 'Last Name'; },
        },
        email: {
            label: function () { return 'Email'; },
        },
        phoneNumber: {
            label: function () { return 'Phone Number'; },
        },
        companyName: {
            label: function () { return 'Company Name'; },
        },
        primaryCta: {
            text: function () { return 'Submit'; },
        },
        secondaryCta: {
            text: function () { return 'Go Back'; },
        },
        errors: {
            required: function () { return 'Required'; },
            invalidEmail: function () { return 'Invalid email'; },
            invalidPhone: function () { return 'Invalid phone number'; },
        },
    },
    thankYouDisplay: {
        title: function () { return 'Thank you for getting in touch'; },
        body: function () { return 'We will get back to you within 2 business days.'; },
    },
    leadFormErrorMessage: function () { return 'Submission not successful. Please try again.'; },
};
export default ContactSalesStrings;
